<script>
    let uploadedImage = new Image();
    let canvas;
    let ctx;

    export let border;
    let hasSelectedBorder = false;
    let hasSelectedImage = false

    $: border.onload = () => {
        console.log(`border.onload fired ${border.src}`);
        hasSelectedBorder = true;
        drawCanvas();
    };

    const handleImageUpload = (event) => {
        console.log("handleImageUpload fired");
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                uploadedImage.src = e.target.result;
                hasSelectedImage = true;
                uploadedImage.onload = () => {
                    drawCanvas();
                };
            };
            reader.readAsDataURL(file);
        }
    };

    const drawCanvas = () => {
        console.log("drawCanvas fired");
        if (uploadedImage) {
            const maxWidth = window.innerWidth * 0.3;
            const maxHeight = window.innerHeight * 0.3;
            const scale = Math.min(
                maxWidth / uploadedImage.width,
                maxHeight / uploadedImage.height,
            );
            canvas.width = uploadedImage.width * scale;
            canvas.height = uploadedImage.height * scale;
            ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(uploadedImage, 0, 0, canvas.width, canvas.height);
            ctx.drawImage(border, 0, 0, canvas.width, canvas.height);
        }
    };

    const downloadImage = () => {
        const link = document.createElement("a");
        link.download = `dibs-borderered.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
    };
</script>

<main>
    <div class="image-upload-download">
        <div class="image-upload">
            <h2>1. Upload Image</h2>
            <input
                type="file"
                id="imageUpload"
                accept="image/*"
                on:change={handleImageUpload}
            />
        </div>
        {#if hasSelectedImage}
            <div class="image">
                <canvas bind:this={canvas} />
            </div>
            {#if hasSelectedBorder}
                <div class="image-download">
                    <button class="download-button" on:click={downloadImage}
                        >3. Download</button
                    >
                </div>
            {/if}
        {/if}
    </div>
</main>

<style>
    .image-upload-download {
        padding: 10px;
    }

    input,
    button {
        font-family: inherit;
        font-size: inherit;
        -webkit-padding: 0.4em 0;
        padding: 0.4em;
        margin: 0 0 0.5em 0;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 2px;
    }

    input::file-selector-button {
        cursor: pointer;
    }

    .image-upload {
        border: none;
    }

    .image {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .image canvas {
        border: 2px solid #333;
        max-width: 100%;
        max-height: 80%;
        background-color: #fff;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .download-button {
        margin-top: 20px;
        padding: 10px 20px;
        background-color: #28a745;
        color: white;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s ease;
    }

    .download-button:hover {
        background-color: #218838;
    }
</style>
